import { render, staticRenderFns } from "./easyplayer.vue?vue&type=template&id=4a67e025"
import script from "./easyplayer.vue?vue&type=script&lang=js"
export * from "./easyplayer.vue?vue&type=script&lang=js"
import style0 from "./easyplayer.vue?vue&type=style&index=0&id=4a67e025&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports